import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

interface ProfileBannerProps {
  companyName?: string;
  displayName?: string;
}

const ProfileBanner: FunctionComponent<ProfileBannerProps> = ({
  companyName,
  displayName,
}) => {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        rowGap: '8px',
        color: '#19262A',
        lineHeight: 'normal',
        mb: 8,
      }}
      data-testid="profileBannerContainer"
    >
      <Box as="h1" sx={{ fontSIze: '32px', fontWeight: 600, mb: 24 }}>
        Profile
      </Box>
      <Flex
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          columnGap: '8px',
          fontSize: '24px',
        }}
      >
        <Box sx={{ fontWeight: 400 }}>CSP Legal Name:</Box>
        <Box sx={{ fontWeight: 700 }} data-testid="companyName">
          {companyName || '--'}
        </Box>
      </Flex>
      <Box
        sx={{
          fontSize: '14px',
          color: '#4d5659',
          fontWeight: 400,
        }}
      >
        CSP DBA Name:{' '}
        <span style={{ fontWeight: 600 }} data-testid="displayName">
          {displayName || '--'}
        </span>
      </Box>
    </Flex>
  );
};

export default ProfileBanner;
